import { createFileRoute } from "@tanstack/react-router";
import { DienstLocatiePage, dienstLocatieHead } from "../components/DienstLocatiePage";
import { verbouwingDordrecht } from "../lib/dienst-locatie-content";

export const Route = createFileRoute("/verbouwing-dordrecht")({
  head: () => dienstLocatieHead(verbouwingDordrecht),
  component: () => <DienstLocatiePage content={verbouwingDordrecht} />,
});
